<div class="filter-wrapper">

  <div class="filter-panel">

    <div class="filter-panel-header">
      <div class="filter-panel-header-main">
        <span class="filter-panel-title">Filter</span>
        <span class="msg-count">{{ messageCount }} st</span>
      </div>
      @if (!isReadOnly()) {
        <button
          mat-raised-button
          color="primary"
          class="create-btn"
          (click)="createMessage()"
          >
          <mat-icon>add</mat-icon> Nytt meddelande
        </button>
      }
    </div>

    <!-- Always visible: status + message type -->
    <div class="filter-panel-primary" [class.is-expanded]="showFilter">

      <div class="filter-primary-toggles">
        <div class="status-toggles">
          <button
            type="button"
            class="filter-chip"
            [class.is-selected]="showActive"
            (click)="onChangeMessageStatus('showActive')"
            >
            <mat-icon>check_circle</mat-icon> Aktiva
          </button>
          <button
            type="button"
            class="filter-chip"
            [class.is-selected]="showPlanned"
            (click)="onChangeMessageStatus('showPlanned')"
            >
            <mat-icon>schedule</mat-icon> Planerade
          </button>
          <button
            type="button"
            class="filter-chip"
            [class.is-selected]="showClosed"
            (click)="onChangeMessageStatus('showClosed')"
            >
            <mat-icon>cancel</mat-icon> Stängda
          </button>
        </div>

        <div class="type-toggles">
          <button
            type="button"
            class="filter-chip filter-chip--app"
            [class.is-selected]="showApp"
            (click)="onChangeMessageType('showApp')"
            >
            <mat-icon>phone_android</mat-icon> Appen
          </button>
          <button
            type="button"
            class="filter-chip filter-chip--tot"
            [class.is-selected]="showTOT"
            (click)="onChangeMessageType('showTOT')"
            >
            <mat-icon>train</mat-icon> Tåg i Tid
          </button>
        </div>
      </div>

      <button type="button" class="expand-toggle" (click)="toggleExpansion()">
        <mat-icon>{{ showFilter ? 'expand_less' : 'expand_more' }}</mat-icon>
        {{ showFilter ? 'Färre filter' : 'Fler filter' }}
        @if (!showFilter && hasHiddenFilter()) {
          <span class="active-dot"></span>
        }
      </button>
    </div>

    <!-- Collapsible advanced filters -->
    @if (showFilter) {
      <div class="filter-panel-expanded">
        <div class="filter-grid">
          <div class="filter-field">
            <label>Rubrik / Händelse</label>
            <input class="text-input" [(ngModel)]="filter.heading" (keyup.enter)="onEnter()" placeholder="Rubrik/Händelse" />
          </div>
          <div class="filter-field">
            <label>Plats</label>
            <input class="text-input" [(ngModel)]="filter.location" (keyup.enter)="onEnter()" placeholder="Plats" />
          </div>
          <div class="filter-field">
            <label>Berörda</label>
            <input class="text-input" [(ngModel)]="filter.affects" (keyup.enter)="onEnter()" placeholder="Berörda" />
          </div>
          <div class="filter-field">
            <label>Skapad/uppdaterad av</label>
            <input class="text-input" [(ngModel)]="filter.createdOrUpdatedBy" (keyup.enter)="onEnter()" placeholder="Namn" />
          </div>
          <div class="filter-field">
            <label>Visas från</label>
            <mat-form-field class="amigo-date-field">
              <input matInput [matDatepicker]="fromPicker" [(ngModel)]="filter.from" placeholder="Från datum">
              <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
              <mat-datepicker #fromPicker></mat-datepicker>
            </mat-form-field>
            <div class="calendar-footer">
              <button type="button" mat-button class="date-action" (click)="setToday('from')">Idag</button>
              <button type="button" mat-button class="date-action" (click)="clearDateField('from')">Rensa</button>
            </div>
          </div>
          <div class="filter-field">
            <label>Visas till</label>
            <mat-form-field class="amigo-date-field">
              <input matInput [matDatepicker]="toPicker" [(ngModel)]="filter.to" placeholder="Till datum">
              <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
              <mat-datepicker #toPicker></mat-datepicker>
            </mat-form-field>
            <div class="calendar-footer">
              <button type="button" mat-button class="date-action" (click)="setToday('to')">Idag</button>
              <button type="button" mat-button class="date-action" (click)="clearDateField('to')">Rensa</button>
            </div>
          </div>
        </div>
        <div class="filter-bottom-row">
          <div class="filter-field">
            <label>Senast uppdaterad</label>
            <mat-form-field class="amigo-date-field">
              <input matInput [matDatepicker]="updatedPicker" [(ngModel)]="filter.lastUpdatedAt" placeholder="Uppdaterad datum">
              <mat-datepicker-toggle matIconSuffix [for]="updatedPicker"></mat-datepicker-toggle>
              <mat-datepicker #updatedPicker></mat-datepicker>
            </mat-form-field>
            <div class="calendar-footer">
              <button type="button" mat-button class="date-action" (click)="setToday('lastUpdatedAt')">Idag</button>
              <button type="button" mat-button class="date-action" (click)="clearDateField('lastUpdatedAt')">Rensa</button>
            </div>
          </div>
          <div class="search-actions">
            <button type="button" mat-stroked-button class="btn-clear" (click)="onClear()">
              <mat-icon>close</mat-icon> Rensa
            </button>
            <button type="button" mat-raised-button color="primary" class="btn-search" (click)="onFilter()">
              <mat-icon>search</mat-icon> Sök
            </button>
          </div>
        </div>
      </div>
    }

    <div class="filter-sort-bar">
      <span class="field-label">Sortera på</span>
      <div class="sort-toggles">
        @for (option of sortingOptions; track option) {
          <button
            type="button"
            class="filter-chip"
            [class.is-selected]="isSortSelected(option)"
            (click)="selectSort(option)"
            >
            {{ option.shortName }}
          </button>
        }
      </div>
    </div>
  </div>
</div>
